import { Form, InputGroup } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

export default function PhoneInput({
  phone,
  setPhone,
  selectedAreaCode,
  setSelectedAreaCode,
  isValid,
  setIsValid,
  msgErrorPhoneNumber,
}) {
  const { t } = useTranslation();

  const AreaCodes = [
    { id: 0, AreaCode: "962", countryCode: "JO", format: "7XXXXXXXX" }, // Jordan format
    { id: 1, AreaCode: "1", countryCode: "USA", format: "XXXXXXXXXX" }, // USA format (removed spaces)
  ];

  const validatePhoneNumber = (input, AreaCode) => {
    const usaRegex = /^\d{10}$/; // USA: 10 digits
    const jordanRegex = /^7\d{8}$/; // Jordan: 9 digits, starts with 7

    if (AreaCode === "1") return usaRegex.test(input);
    if (AreaCode === "962") return jordanRegex.test(input);
    return false;
  };

  const formatPhoneNumber = (input) => input.replace(/\D/g, ""); // Remove all non-numeric characters

  const handlePhoneChange = (e) => {
    const input = e.target.value;
    const formattedPhone = formatPhoneNumber(input);
    setPhone(formattedPhone);
    setIsValid(validatePhoneNumber(formattedPhone, selectedAreaCode));
  };

  useEffect(() => {
    if (phone && !phone.startsWith(`+${selectedAreaCode}`)) {
      setPhone(`${phone.replace(/^[^0-9]+/, "")}`);
    }
  }, [selectedAreaCode]);

  return (
    <Form.Group className="mb-3">
      <Form.Label className="font-SemiBold">{t("Phone Number")}</Form.Label>
      <InputGroup className="select-phone">
        <div>
          <Form.Select
            className={`${!isValid ? "border-danger" : ""}`}
            aria-label="Select country code"
            value={selectedAreaCode}
            onChange={(e) => {
              setSelectedAreaCode(e.target.value);
              setPhone("");
            }}
            isInvalid={!isValid}
          >
            {AreaCodes.map((item) => (
              <option key={item.id} value={item.AreaCode}>
                +{item.AreaCode}
              </option>
            ))}
          </Form.Select>
        </div>
        <Form.Control
          type="tel"
          name="PhoneNumber"
          className={`custome-form-control px-2 ${
            !isValid ? "is-invalid" : ""
          }`}
          placeholder={t("Enter phone number")}
          value={phone}
          onChange={handlePhoneChange}
          required
          isInvalid={!isValid}
        />

        <Form.Control.Feedback type="invalid">
          {msgErrorPhoneNumber
            ? t(msgErrorPhoneNumber)
            : !isValid && phone
            ? t("Please enter a valid phone number")
            : t("Please enter") + " " + t("Phone Number")}
        </Form.Control.Feedback>
      </InputGroup>
    </Form.Group>
  );
}
